import { UIRouterGlobals } from "@uirouter/angular";
import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { take } from "rxjs";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { DayjsDateModule } from "@webapp/shared/pipes/dayjs-date/dayjs-date.module";
import { TeamsRepository } from "@webapp/teams/services/teams-repository.service";
import { UiAssigneeModule } from "@webapp/ui/assignee/assignee.module";

@UntilDestroy()
@Component({
  selector: "team-header",
  templateUrl: "./team-header.component.html",
  styleUrls: ["./team-header.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, UiAssigneeModule, AssigneesModule, LocalizationModule, DayjsDateModule],
})
export class TeamHeaderComponent implements OnInit {
  public teamCreatedOnDate: string;

  public get teamId(): string {
    return this.routerGlobals.params["teamId"];
  }

  constructor(private routerGlobals: UIRouterGlobals, private teamsRepository: TeamsRepository) {}

  public ngOnInit(): void {
    this.teamsRepository
      .getMap$()
      .pipe(untilDestroyed(this), take(1))
      .subscribe((teamsMap) => {
        this.teamCreatedOnDate = teamsMap.get(this.teamId).dateCreated;
      });
  }
}
